const globalStyles = {
  "@global": {
    body: {
      margin: 0,
      boxSizing: "border-box",
    },
    "*": {
      boxSizing: "inherit",
    },
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: "Futura, serif",
      fontWeight: 600,
    },
    "div, button, p, span": {
      fontFamily: "Jost, sans-serif",
      fontWeight: 400,
    },
    p: {
      fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    },
  },
}

export const CONTAINER_STYLE = {
  width: "100%",
  maxWidth: "1000px",
}

export const BREAKPOINT = 500 // px
export const TRANSITION_DURATION = 0.5 // seconds

export default globalStyles
